import moment from "moment";
import Big from "big.js";

export default {
  data: function () {
    return {
      screenWidth: window.innerWidth,
    };
  },
  mounted: function () {
    window.addEventListener("resize", this.onUtilityResize);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.onUtilityResize);
  },
  methods: {
    promiseSleep: function (sleepTime) {
      return new Promise((resolve) => {
        setTimeout(() => {
          return resolve();
        }, sleepTime);
      });
    },
    getPageUrlParameters() {
      let params = null;

      let paramsString = window.location.search;
      if (!this.isNullOrEmpty(paramsString)) {
        paramsString = paramsString.substr(1);
        if (!this.isNullOrEmpty(paramsString)) {
          params = this.getAllUrlParams(paramsString);
        }
      }

      return params;
    },
    getAllUrlParams(urlParameters) {
      let result = null;

      if (!this.isNullOrEmpty(urlParameters)) {
        let query = urlParameters;
        result = {};
        query.split("&").forEach(function (part) {
          let index = part.indexOf("=");
          if (index !== -1) {
            let value = part.substring(index + 1);
            let key = part.substring(0, index);
            result[key] = decodeURIComponent(value);
          }
        });
      }

      return result;
    },
    isValidEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    isValidPassword: function (password) {
      const re = /^(?=.*\d)(?=.*[~`!@#\$%\^\&*\)\(+=._-])(?=.*[a-z])(?=.*[A-Z]).{15,}$/;
      return re.test(password);
    },
    getDateAsStandardFormatString: function (dateValue) {
      let result = "";

      if (!this.isNull(dateValue) && dateValue > 0) {
        let momentValue = moment(dateValue);
        result = momentValue.format("YYYY-MM-DDTHH:mm:ss");
      }

      return result;
    },
    numberAsDollarString: function (numberValue) {
      let trunctedNumberValue = this.truncateBigDecimalPlaces(numberValue, 2);
      let result = this.convertNumberToDollarString(
        trunctedNumberValue.valueOf()
      );
      return result;
    },
    convertNumberToDollarString: function (numberStringValue) {
      let result = "";

      result = this.numberWithCommas(numberStringValue);

      if (!this.isNullOrEmpty(result)) {
        if (result.indexOf(".") === -1) {
          result += ".00";
        } else {
          let index = result.lastIndexOf(".") + 1;
          let checkDecimalsString = result.substring(index);

          if (this.isNullOrEmpty(checkDecimalsString)) {
            result += "00";
          } else if (checkDecimalsString.length === 1) {
            result += "0";
          }
        }
      }

      result = "$" + result;

      return result;
    },
    numberWithCommas: function (numberStringValue) {
      if (this.isNullOrEmpty(numberStringValue)) {
        return "";
      }

      let parts = numberStringValue.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    truncateBigDecimalPlaces: function (numberValue, places) {
      let result;

      let truncateNumber = false;

      if (!this.isNull(numberValue)) {
        let numberValueString = numberValue.toString();
        if (numberValueString.indexOf(".") !== -1) {
          let index = numberValueString.lastIndexOf(".") + 1;
          let checkDecimalsString = numberValueString.substring(index);
          if (
            !this.isNullOrEmpty(checkDecimalsString) &&
            checkDecimalsString.length > places
          ) {
            truncateNumber = true;
          }
        }
      }

      if (truncateNumber) {
        result = new Big(numberValue.toFixed(places));
      } else {
        result = numberValue;
      }

      return result;
    },
    getNumber: function (value, defaultValue) {
      let result = defaultValue;

      if (!this.isNull(value) && !isNaN(value)) {
        result = Number(value);
      }

      return result;
    },
    getBoolean: function (value, defaultValue) {
      let result = defaultValue;

      if (!this.isNull(value)) {
        if (value === true || value === "true") {
          result = true;
        } else {
          result = false;
        }
      }

      return result;
    },
    getString: function (value, defaultValue) {
      let result = defaultValue;

      if (!this.isNull(value)) {
        result = value;
      }

      return result;
    },
    getBigDecimal: function (value, defaultValue) {
      let result = null;

      try {
        if (!this.isNull(defaultValue)) {
          result = new Big(defaultValue);
        }

        if (!this.isNull(value)) {
          const resultValue = new Big(value);
          result = resultValue;
        }
      } catch (e) {
        //console.log("ERROR: " + e); //not handelled
      }

      return result;
    },
    getSignatureImageFromDataString: function (dataString) {
      let self = this;

      return new Promise(function (resolve, reject) {
        if (self.isNull(dataString)) {
          return resolve(null);
        } else {
          let image = new Image();
          image.src = window.atob(dataString);
          image.onload = function () {
            let imageWidth;
            let imageHeight;
            let MAX_SIGNATURE_WIDTH = 200;
            let MAX_SIGNATURE_HEIGHT = 100;
            imageWidth = MAX_SIGNATURE_WIDTH;
            imageHeight = (imageWidth * image.height) / image.width;
            if (imageHeight > MAX_SIGNATURE_HEIGHT) {
              imageHeight = MAX_SIGNATURE_HEIGHT;
              imageWidth = (imageHeight * image.width) / image.height;
            }
            image.width = imageWidth;
            image.height = imageHeight;
            return resolve(image);
          };
        }
      });
    },
    isNull: function (value) {
      let result = false;
      if (value === null || value === undefined) {
        result = true;
      }
      return result;
    },
    isNullOrEmpty: function (value) {
      let result = false;
      if (value === null || value === undefined || value.length <= 0) {
        result = true;
      }
      return result;
    },
    isSmallScreenWidth: function () {
      let result = false;

      if (this.screenWidth <= 768) {
        result = true;
      }

      return result;
    },
    getElementPositionByElement: function (elementItem) {
      let x = 0;
      let y = 0;

      while (!this.isNull(elementItem)) {
        x += elementItem.offsetLeft;
        y += elementItem.offsetTop;
        elementItem = elementItem.offsetParent;
      }

      return { x: x, y: y };
    },
    onUtilityResize: function () {
      this.screenWidth = window.innerWidth;
    },
    showAlertDialog(alertHeaderText, alertBodyText, type = "warning") {
      this.$toast.error(`${alertHeaderText}: ${alertBodyText}`);
    },
  },
};
